import { styled } from "styled-components";
import { theme as defaultTheme, Typography } from "@mindlercare/ui-web";

export const FormContainer = styled.div`
  padding-top: 28px;
  height: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ReplyHeader = styled(Typography)`
  font-weight: ${defaultTheme.FONT.WEIGHT.MEDIUM};
  font-size: ${defaultTheme.FONT.SIZE.LARGE};
  color: ${defaultTheme.COLORS.GRAY_BLACK};
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  position: relative;

  /* Match the old textarea geometry: a roomy min height, a capped max height,
   * and bottom padding so the timestamp and char count can overlay inside the
   * bottom of the textarea without colliding with the text. */
  textarea {
    min-height: 84px;
    max-height: 300px;
    padding: 10px 10px 32px 10px;
    line-height: normal;
    overflow-y: auto;
  }
`;

export const Placeholder = styled.div`
  flex: 1;
`;

export const CharCount = styled.div`
  align-self: flex-end;
  font-size: 12px;
  color: ${defaultTheme.COLORS.GRAY};
  position: absolute;
  bottom: 9px;
  right: 16px;
  user-select: none;
`;

export const ActionContainer = styled.div`
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  align-items: center;
`;
export const ButtonWrapper = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.SPACING.SM};
  align-self: end;
`;

export const TimestampContainer = styled.div`
  align-self: flex-start;
  font-size: 12px;
  color: ${defaultTheme.COLORS.GRAY};
  position: absolute;
  bottom: 9px;
  left: 16px;
  user-select: none;
`;
